import globalConfig from '../utiles/globalConfig';

export default {
  data() {
    return {
      supportSafeAreaLandscape: globalConfig.supportSafeAreaLandscape(),
    };
  },
};
